export default __webpack_public_path__ + "static/media/about-section-one.a68a544d.png";